export const TEMPLATES = {
  DEFAULT: 'DEFAULT',
  ONLINE_EVENT: 'ONLINE_EVENT'
};

export const RGB_COLORS = {
  BLUE: '#3498db',
  GRAY: '#95a5a6',
  BLACK: '#323232',
  RED: '#e74c3c',
  GREEN: '#30CC69',
  ORANGE: '#e67e22',
  YELLOW: '#F1C40D',
  PINK: '#ff80ab',
  INDIGO: '#2c3e50',
  TURQUOISE: '#1cc9a8',
  PURPLE: '#9b59b6',
  LIGHT_BLUE: '#81cfe0',
  DARK_GREEN: '#16a085',
  DARK_BLUE: '#0c3f7a'
};

export const CERTIFICATE_LABEL_PREFIX = 'certificate.';

export const FILE_ID_LENGTH = {
  NEW: 36,
  OLD: 10
};

export const SETTINGS_ACTIVATE = 'settings-activate';

export const CONFIG_TABS = {
  DATA: 0,
  CUSTOM: 1,
  CERTIFICATE: 2,
  HELP: 3,
  STREAMING: 4,
  SPARKLE: 5,
  ZENDESK: 6
};

export const ANALYTICS_SCRIPT_FORMAT_V4 = 'G-XXXXXXX';
export const ANALYTICS_SCRIPT_FIND_ID_LINK =
  'https://support.google.com/analytics/answer/12270356';
export const ANALYTCS_SCRIPT_V4_LEARN_MORE_LINK =
  'https://support.google.com/analytics/answer/11583528';
